<div id="card-element" #paymentElement>
  <!-- A Stripe Element will be inserted here. -->
</div>
<div id="payment-errors" role="alert">&nbsp;{{ error }}</div>
